<template>
  <div>
    <!-- Button -->
    <button
      type="button"
      class="btn btn-sm btn-outline-light"
      data-bs-toggle="tooltip"
      data-bs-delay="500"
      title="Export all Admissions and Observations for this Investigation."
      :disabled="isExporting"
      @click="excelExport"
    >
      <fa v-if="isExporting" icon="circle-notch" spin />
      <fa v-if="!isExporting" icon="file-excel" fixed-width />
      Export
    </button>
  </div>
</template>

<script>
export default {
  props: {
    investigation: Object,
  },
  data() {
    return {
      isExporting: false,
    };
  },
  methods: {
    excelExport() {
      this.isExporting = true;
      this.$axios
        .post(`/v1/organizations/${this.investigation.organizationId}/investigations/${this.investigation.investigationId}/export/excel`)
        .then(res => {
          const link = document.createElement("a");
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.href = res.data.url;
          link.click();
          link.remove();
        })
        .finally(() => (this.isExporting = false));
    },
  },
};
</script>
